{
  "page": {
    "rating": {
      "new": "עסק חדש"
    },
    "nextFree": {
      "label": "הפנוי הקרוב",
      "value": "{day} · {time}",
      "cta": "קבעו"
    },
    "services": {
      "title": "בחרו שירות"
    },
    "service": {
      "meta": "{min} · {price}",
      "deposit": "מקדמה {amount}"
    },
    "gallery": {
      "title": "עבודות"
    },
    "staff": {
      "title": "עם מי?",
      "any": "מי שפנוי"
    },
    "footer": {
      "built": "הדף הזה נבנה ב-Planella",
      "cta": "צרו דף כזה",
      "a11y": "נגישות",
      "privacy": "פרטיות",
      "builtWith": "נבנה עם"
    },
    "unknown": {
      "title": "הדף לא נמצא",
      "sub": "בדקו את הלינק או שאלו את העסק."
    },
    "closed": {
      "title": "העסק לא מקבל תורים כרגע",
      "sub": "אפשר ליצור קשר בוואטסאפ."
    },
    "error": "לא הצלחנו לטעון את הדף.",
    "noServices": "עוד אין שירותים להזמנה."
  },
  "time": {
    "title": "מתי נוח?",
    "summary": "{service} · {min} · {price}",
    "month": "{month}",
    "day": {
      "aria": "{day}, {count}",
      "none": "{day}, אין שעות פנויות"
    },
    "cta": "המשיכו",
    "none": {
      "day": "אין שעות פנויות ב{day}.",
      "jump": "קפצו ל{day}",
      "week": {
        "text": "השבוע מלא.",
        "jump": "הפנוי הקרוב: {day}, {time}"
      },
      "all": "אין שעות פנויות בחודשים הקרובים."
    },
    "waitlist": {
      "link": "אין שעה מתאימה? הצטרפו לרשימת המתנה"
    },
    "error": "לא הצלחנו לטעון שעות.",
    "loadingNext": "מחפשים שעות…",
    "skip": "דלגו לשעות"
  },
  "details": {
    "title": "הפרטים שלכם",
    "summary": "{service} · {when}",
    "name": "שם",
    "phone": "טלפון",
    "returning": {
      "text": "ברוכים השבים, {name}",
      "clear": "לא אני"
    },
    "consent": {
      "title": "הודעות",
      "hintWhy": "בלי אישור לא נשלח תזכורת."
    },
    "cta": {
      "text": "קבעו תור",
      "deposit": "שלמו מקדמה · {amount}",
      "busy": "קובעים…"
    },
    "rate": "יותר מדי ניסיונות. נסו שוב בעוד דקה.",
    "error": "לא הצלחנו לקבוע. נסו שוב.",
    "noshow": {
      "consent": "אישור חיוב {fee} על אי הגעה"
    },
    "method": {
      "title": "איך משלמים את המקדמה?"
    }
  },
  "taken": {
    "title": "השעה הזו נתפסה הרגע.",
    "sub": "הנה 3 שעות קרובות:",
    "none": "אין שעות קרובות. נסו יום אחר.",
    "cta": "בחרו יום אחר"
  },
  "pay": {
    "title": "משלמים מקדמה",
    "amount": "{amount} מקדמה · מנוכה מהמחיר",
    "hold": "השעה שמורה לכם עוד {mm}:{ss}",
    "cta": "שלמו {amount}",
    "giveUp": "ויתרו",
    "processing": "מעבדים תשלום…",
    "terms": "התשלום עובר ישירות לעסק. Planella לא מחזיקה כסף.",
    "failed": {
      "title": "התשלום לא עבר",
      "sub": "השעה עדיין שמורה לכם עד {time}.",
      "cta": "נסו שוב",
      "retryNote": "ננסה לשמור לכם את אותה שעה.",
      "gone": "השעה נתפסה. בחרו אחרת, לא חויבתם."
    },
    "timeout": {
      "title": "הזמן נגמר",
      "sub": "השעה שוחררה. אפשר לבחור שעה חדשה.",
      "cta": "בחרו שעה אחרת"
    },
    "slotLost": "השעה נתפסה בזמן שניסיתם לשלם. לא חויבתם.",
    "offline": {
      "open": {
        "bit": "פתחו בביט",
        "paybox": "פתחו בפייבוקס"
      },
      "toPhone": "או העבירו למספר",
      "copyPhone": "העתיקו את המספר {phone}",
      "copied": "המספר הועתק",
      "hint": "מעבירים, חוזרים לכאן ולוחצים שילמתי.",
      "paid": "שילמתי",
      "error": "לא הצלחנו לשלוח. נסו שוב.",
      "waiting": {
        "title": "מחכים לאישור מ{business}",
        "sub": "ברגע שהתשלום יאושר התור שלכם סגור. אפשר לסגור את הדף.",
        "until": "השעה שמורה לכם עד {time}."
      },
      "terms": "ההעברה ישירות לעסק. Planella לא מחזיקה כסף.",
      "amountLabel": "מקדמה · מנוכה מהמחיר"
    }
  },
  "done": {
    "title": "התור נקבע!",
    "sub": "נתראה ב{day}, בשעה {time}",
    "pending": "ביקשתם תור. {business} תאשר בקרוב.",
    "depositPaid": "המקדמה התקבלה.",
    "cta": "הוסיפו ליומן",
    "share": "שתפו",
    "manage": "ניהול התור",
    "navigate": "נווטו",
    "whatsapp": {
      "yes": "אישור בוואטסאפ בדרך.",
      "no": "לא סימנתם הודעות, אז לא נשלח אישור. שמרו את הלינק."
    },
    "copyLink": "העתיקו לינק לתור",
    "line": "נתראה!"
  },
  "wl": {
    "join": {
      "title": "רשימת המתנה",
      "sub": "נעדכן כשתתפנה שעה.",
      "days": "באילו ימים?",
      "daypart": "באיזו שעה?",
      "cta": {
        "text": "הוסיפו אותי",
        "done": "חזרה לדף"
      },
      "done": {
        "text": "נרשמתם לרשימה",
        "sub": "נשלח לכם הודעה כשתתפנה שעה.",
        "noConsent": "לא סימנתם הודעות, אז לא נוכל לעדכן. חזרו לבדוק בדף."
      },
      "exists": "כבר ברשימה. עדכנו את הימים.",
      "consentNote": "בלחיצה על \"הוסיפו אותי\" אתם מאשרים הודעות וואטסאפ על שעה שתתפנה. אפשר להסיר בכל רגע.",
      "daysChosen": "הימים שבחרתם",
      "adjust": "התאימו (לא חובה)",
      "allDays": "כל הימים הפנויים",
      "anyHour": "בכל שעה"
    }
  },
  "offer": {
    "title": "התפנתה שעה",
    "timer": "בתוקף עוד {mm}:{ss}",
    "cta": "אשרו את התור",
    "decline": "לא מתאים",
    "taken": {
      "title": "נתפס הרגע",
      "sub": "נשארתם ברשימה ונעדכן כשתתפנה שעה אחרת."
    },
    "expired": {
      "title": "ההצעה פגה",
      "sub": "חלפו 30 דקות או שהשעה קרובה מדי.",
      "cta": "לדף הזמנות"
    },
    "done": {
      "title": "השעה שלכם!"
    },
    "invalid": {
      "title": "ההצעה לא נמצאה",
      "sub": "ייתכן שהלינק ישן."
    },
    "when": "התור שלכם"
  },
  "manage": {
    "title": "התור שלכם",
    "when": "{day}, {time}",
    "where": "{address}",
    "move": {
      "text": "הזיזו",
      "title": "לאיזה מועד?",
      "suggest": "הכי קרוב",
      "other": "ימים אחרים",
      "cta": "אשרו מועד חדש",
      "done": "התור הוזז. נתראה {when}",
      "none": {
        "text": "אין מועדים פנויים כרגע.",
        "cta": "לרשימת המתנה"
      },
      "late": "אי אפשר להזיז תור פחות מ-{hours} שעות לפניו. אפשר לדבר עם העסק."
    },
    "cancel": {
      "text": "בטלו תור",
      "title": "לבטל את התור?",
      "cta": "כן, בטלו את התור",
      "keep": "השאירו את התור",
      "done": {
        "title": "התור בוטל",
        "sub": "רוצים מועד אחר?",
        "cta": "בחרו מועד"
      }
    },
    "status": {
      "cancelled": "התור הזה בוטל",
      "past": "התור הזה כבר עבר",
      "rebook": "קבעו שוב",
      "awaiting": {
        "text": "ממתין למקדמה. השעה שמורה עוד {mm}:{ss}.",
        "cta": "שלמו מקדמה"
      }
    },
    "expired": {
      "title": "הקישור לא בתוקף",
      "sub": "אולי התור כבר עבר או בוטל.",
      "cta": "מצאו את התור לפי טלפון"
    },
    "find": {
      "title": "מה הטלפון שלכם?",
      "cta": "שלחו קוד",
      "otp": "הקלידו את הקוד",
      "none": "לא מצאנו תורים קרובים בטלפון הזה.",
      "list": "התורים שלכם"
    },
    "offline": "אין חיבור, אז אי אפשר לשנות עכשיו."
  },
  "method": {
    "card": "כרטיס",
    "bit": "ביט",
    "paybox": "פייבוקס",
    "cash": "מזומן"
  },
  "venue": {
    "title": "תשלום במקום:",
    "sep": ", "
  },
  "photos": {
    "title": "עבודות",
    "alt": "עבודה של {business}, תמונה {n}",
    "open": "פתחו תמונה {n} מתוך {total}",
    "prev": "התמונה הקודמת",
    "next": "התמונה הבאה",
    "count": "{n} מתוך {total}",
    "more": "כל {n}"
  },
  "erase": {
    "cta": "מחקו את הפרטים שלי",
    "title": "למחוק את הפרטים שלכם?",
    "text": "השם, הטלפון וההערות שלכם אצל {business} יימחקו לצמיתות.",
    "upcoming_one": "התור הקרוב שלכם יבוטל, בלי חיוב. מקדמה תוחזר.",
    "upcoming_two": "{count} התורים הקרובים שלכם יבוטלו, בלי חיוב. מקדמה תוחזר.",
    "upcoming_other": "{count} התורים הקרובים שלכם יבוטלו, בלי חיוב. מקדמה תוחזר.",
    "noUpcoming": "אין לכם תורים עתידיים.",
    "stats": "נשארת רשומה אנונימית של התור, בלי שם וטלפון.",
    "link": "קישור הניהול הזה יפסיק לעבוד.",
    "confirm": "כן, מחקו",
    "keep": "לא, השאירו",
    "doneTitle": "הפרטים נמחקו",
    "doneText": "תודה. השם והטלפון שלכם כבר לא אצלנו.",
    "error": "המחיקה נכשלה. נסו שוב."
  }
}
